<!--List Group starts-->
<section id="list">
  <div class="row">
    <div class="col-12">
      <div class="content-header">List</div>
      <p class="content-sub-header mb-1">List groups are a flexible and powerful component for displaying not only simple lists of elements, but complex ones with custom content.</p>
    </div>
  </div>
  <div class="row match-height">
    <!--Basic List Group Starts-->
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic example</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>The most basic list group is simply an unordered list with list items, and the proper classes. </p>
            <ul class="list-group">
              <li class="list-group-item">Cras justo odio</li>
              <li class="list-group-item">Dapibus ac facilisis in</li>
              <li class="list-group-item">Morbi leo risus</li>
              <li class="list-group-item">Porta ac consectetur ac</li>
              <li class="list-group-item">Vestibulum at eros</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--Basic List Group Ends-->

    <!--List Group with badges Starts-->
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Badges</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Add the badges component to any list group item and it will automatically be positioned on the right.</p>
            <ul class="list-group">
              <li class="list-group-item">
                <span class="badge badge-primary mr-2">7</span> Cras justo odio
              </li>
              <li class="list-group-item">
                <span class="badge badge-danger mr-2">2</span> Dapibus ac facilisis in
              </li>
              <li class="list-group-item">
                <span class="badge badge-success mr-2">1</span> Morbi leo risus
              </li>
              <li class="list-group-item">
                <span class="badge badge-warning mr-2">4</span> Porta ac consectetur ac
              </li>
              <li class="list-group-item">
                <span class="badge badge-info mr-2">8</span> Vestibulum at eros
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--List Group with badges Ends-->

    <!--List Group with Linked items Starts-->
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Linked items</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Linkify list group items by using anchor tags instead of list items. No need for individual parents around each element.</p>
            <div class="list-group">
              <a href="javascript:;" class="list-group-item active">Cras justo odio</a>
              <a href="javascript:;" class="list-group-item">Dapibus ac facilisis in</a>
              <a href="javascript:;" class="list-group-item">Morbi leo risus</a>
              <a href="javascript:;" class="list-group-item">Porta ac consectetur ac</a>
              <a href="javascript:;" class="list-group-item">Vestibulum at eros</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--List Group with Linked items Ends-->

    <!--List Group with Button items Starts-->
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Button items</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>List group items may be buttons instead of list items. No need for individual parents around each element. <b>Don't use the standard <code>.btn</code> classes here.</b></p>
            <div class="list-group">
              <button type="button" class="list-group-item">Cras justo odio</button>
              <button type="button" class="list-group-item">Dapibus ac facilisis in</button>
              <button type="button" class="list-group-item">Morbi leo risus</button>
              <button type="button" class="list-group-item">Porta ac consectetur ac</button>
              <button type="button" class="list-group-item">Vestibulum at eros</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--List Group with Button items Ends-->

    <!--List Group with Disabled list items Starts-->
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Disabled items</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Add <code>.disabled</code> to a <code>.list-group-item</code> to gray it out to appear disabled.</p>
            <ul class="list-group">
              <li class="list-group-item disabled">Cras justo odio</li>
              <li class="list-group-item">Dapibus ac facilisis in</li>
              <li class="list-group-item">Morbi leo risus</li>
              <li class="list-group-item">Porta ac consectetur ac</li>
              <li class="list-group-item">Vestibulum at eros</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--List Group with Disabled list items Ends-->

    <!--Contextual classes Starts-->
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Contextual classes</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use contextual classes to style list items, default or linked. Also includes <code>.active</code> state.</p>
            <ul class="list-group">
              <li class="list-group-item list-group-item-primary">Porta ac consectetur ac</li>
              <li class="list-group-item list-group-item-success">Dapibus ac facilisis in</li>
              <li class="list-group-item list-group-item-info">Cras sit amet nibh libero</li>
              <li class="list-group-item list-group-item-warning">Porta ac consectetur ac</li>
              <li class="list-group-item list-group-item-danger">Vestibulum at eros</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--Contextual classes Ends-->
  </div>
  <div class="row match-height">
    <!--Custom content Starts-->
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Custom content</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Add nearly any HTML within, even for linked list groups like the one below.</p>
            <ul class="list-group">
              <li class="list-group-item list-group-item-action flex-column align-items-start active">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="white mb-3">List group item heading</h5>
                  <small>3 days ago</small>
                </div>
                <p class="white mb-2">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p>
                <small>Donec id elit non mi porta.</small>
              </li>
              <li class="list-group-item list-group-item-action flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-3">List group item heading</h5>
                  <small class="text-muted">3 days ago</small>
                </div>
                <p class="mb-2">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p>
                <small class="text-muted">Donec id elit non mi porta.</small>
              </li>
              <li class="list-group-item list-group-item-action flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-3">List group item heading</h5>
                  <small class="text-muted">3 days ago</small>
                </div>
                <p class="mb-2">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p>
                <small class="text-muted">Donec id elit non mi porta.</small>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--Custom content Ends-->

    <!--Contextual Action Starts-->
    <div class="col-12 col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Contextual Action</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Contextual classes also work with <code>.list-group-item-action</code>. Also supported is the <code>.active</code> state; apply it to indicate an active selection on a contextual list group item.</p>
            <ul class="list-group">
              <li class="list-group-item list-group-item-action">Dapibus ac facilisis in</li>
              <li class="list-group-item list-group-item-action list-group-item-primary">This is a primary list group item</li>
              <li class="list-group-item list-group-item-action list-group-item-secondary">This is a secondary list group item</li>
              <li class="list-group-item list-group-item-action list-group-item-success">This is a success list group item</li>
              <li class="list-group-item list-group-item-action list-group-item-danger">This is a danger list group item</li>
              <li class="list-group-item list-group-item-action list-group-item-warning">This is a warning list group item</li>
              <li class="list-group-item list-group-item-action list-group-item-info">This is a info list group item</li>
              <li class="list-group-item list-group-item-action list-group-item-light">This is a light list group item</li>
              <li class="list-group-item list-group-item-action list-group-item-dark">This is a dark list group item</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--Contextual Action Starts-->
  </div>
</section>
<!--List Group starts-->
